import React, { useContext } from "react";
import { MobileContext, Text } from "components/common";
import Offer from "./Offer";

const OffersTile = ({ className = "", offers, showOffers }) => {
  const { isMobile } = useContext(MobileContext);

  if (!showOffers) {
    return null;
  }

  const offersToShow = isMobile ? 2 : 3;
  let offerCmps = [];
  if (offers?.length > 0) {
    offerCmps = offers
      .slice(0, Math.min(offersToShow, offers?.length))
      .map((offer) => (
        <Offer className="px-2 w-1/2 md:w-1/3" offer={offer} key={offer.name} />
      ));
  }

  if (offers?.length < offersToShow || !offers?.length) {
    offerCmps.push(
      <Offer
        className="mt-4 md:mt-0 px-2 w-full sm:w-1/2 md:w-1/3"
        key="more"
      />,
    );
  }

  return (
    <div className={`${className}`}>
      <div className="rounded-sm common-container h-auto text-center sm:text-left bg-fog-gray">
        <Text title>Your Offers</Text>
        <div className="flex flex-wrap justify-center md:justify-start -mx-2 mt-2">
          {offerCmps}
        </div>
      </div>
    </div>
  );
};

export default OffersTile;
